export const iconFontAwesomeGamingBookSkull = (
	<i className="fa-solid fa-book-skull"></i>
);
